import React from "react";
import eLogo from "@/assets/branding/eLogo.svg";

/*
  ------------------------------------------------------
  Mobile interview end screen – shown after laptop signals completion
  ------------------------------------------------------
*/
const MobileInterviewEnded: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-6 py-10 text-center">
      <div className="mb-10 flex items-center justify-center gap-2">
        <img src={eLogo} alt="EmployAbility Logo" className="w-8 h-8" />
        <span className="text-xl font-ubuntu font-bold text-[#001630]">
          Employ<span className="text-[#0AD472]">Ability.AI</span>
        </span>
      </div>

      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white px-6 py-8 shadow-sm">
        <h1 className="text-2xl font-ubuntu font-medium text-[#001630] mb-3">Interview Completed</h1>
        <p className="text-sm text-gray-600 leading-6 mb-6">
          Your interview has finished. You can close this tab now.
          <br />
          If your interviewer needs anything else, return to your laptop.
        </p>
        <button
          type="button"
          onClick={() => window.location.replace("/")}
          className="w-full rounded-lg bg-[#001630] px-4 py-3 text-sm font-ubuntu text-white transition hover:bg-[#001630e6]"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default MobileInterviewEnded;

